import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlDashboardResponse } from "../models/service-models/dashboard/DashboardResponse";
import { mdlDashboardStatsRequest } from "../models/service-models/dashboard/DashboardRequest";
import { GetResponse } from "../utils/ApiClient";
import dayjs from 'dayjs';

class DashboardService {
    async getStats(request: mdlDashboardStatsRequest): Promise<mdlDashboardResponse> {
        try {
            const response = await GetResponse<mdlServiceResponse<mdlDashboardResponse>>(
                "dashboard/stats",
                request
            );

            if (response.header.success) {
                console.log('Dashboard API Response:', response.body?.chartData);
                return response.body!;
            }

            throw new Error(response.header.messages?.[0]?.message || 'Failed to fetch dashboard data');

        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            throw error;
        }
    }
}

export const dashboardService = new DashboardService(); 